<template>
    <div>
        <h1>{{$t('global.menu.contacts')}}</h1>
        <template v-if="!autoAccept">
            <div class="row">
                <div class="col-md-12 text-center">
                    <i18n path="contacts.addURL.confirmation">
                        <b>{{ token }}</b>
                    </i18n>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3 text-center">
                    <button class="btn btn-primary" @click="$router.push({ name: 'ContactList' })">
                        {{$t('global.modal.cancel')}}
                    </button>
                    <button class="btn btn-primary" @click="pair">{{$t('global.modal.ok')}}</button>
                </div>
            </div>
        </template>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';

export default {
    data: function () {
        return {
            token: '',
        };
    },
    computed: mapGetters({
        loading: 'loading/loading/loading',
        addedContact: 'contact/pair/addedContact',
    }),
    props: {
        autoAccept: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        pair: function () {
            if (this.token) {
                this.$store
                    .dispatch('contact/pair/useToken', this.token)
                    .then(() => {
                        this.$router.push({name: 'ContactList', params: {highlight: this.addedContact.id}});
                    });
            }
        },
    },
    created() {
        this.$store.dispatch('contact/pair/reset');
        this.token = this.$route.params.token;
        if (this.autoAccept) {
            this.pair();
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/contact/PairURL.vue